import { render, staticRenderFns } from "./Toribia1.vue?vue&type=template&id=02135791&scoped=true"
import script from "./Toribia1.vue?vue&type=script&lang=js"
export * from "./Toribia1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02135791",
  null
  
)

export default component.exports